// extracted by mini-css-extract-plugin
module.exports = {"link":"_2XOns","image":"_1WIgh","root":"_2_kvP","ScotchA":"OhscO","scotchA":"OhscO","ScotchB":"eMuU6","scotchB":"eMuU6"};